import { Component } from '@angular/core';
import { CartOutlets } from '@spartacus/cart/base/root';
import {QuoteItemsComponent} from "@spartacus/quote/components";
import { QuoteService } from '@spartacus/quote/core';
import { map, Observable } from 'rxjs';
import {GonvarriQuote} from "../../core/models/gonvarri-quote.model";

@Component({
    selector: 'app-gonvarri-quote-items',
    templateUrl: './gonvarri-quote-items.component.html',
    styleUrl: './gonvarri-quote-items.component.scss',
    standalone: false
})
export class GonvarriQuoteItemsComponent extends QuoteItemsComponent {
  override readonly cartOutlets = CartOutlets;

  quote$: Observable<GonvarriQuote> = this.quoteService.getQuoteDetails() as any;

  quoteIsReadOnly$: Observable<boolean> = this.quoteItemsData$.pipe(
    map(quoteItemsData => quoteItemsData.readOnly)
  );

  constructor(protected quoteService: QuoteService) {
    super();
  }

}
